module.exports = __webpack_public_path__ + "static/img/caigoudan.dfe0488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caigoudan.png
// module id = P/fH
// module chunks = 1